module.exports = __webpack_public_path__ + "img/icone-maquinario.eeaff53a.svg";